import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Card } from '../../../../../../shared/card/card'
import { Form, FormSubmit, FormText } from '../../../../../../shared/form/form'
import { useApiFormNodeTemplate, useApiListAsset } from '../../../../../../api-new/state/content'
import { useLoad } from '../../../../../../shared/hooks/load'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TemplateMenu } from '../../common/menu/node-actions'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { ThumnailAsset } from '../../common/thumbnail/thumbnail-asset'
import { useDataContext } from '../data-context'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'
import { PublishAssetList } from '../../common/publish/publish-asset-list'
// import { NodeTags } from '../../common/shared/node-tags'

export const NodeTemplateEdit = ({ parentURL, nodeID }) => {
  const apiFormTemplate = useApiFormNodeTemplate()
  const apiListAsset = useApiListAsset()

  const roleOrgNode = useRoleOrgNode()

  const dataContext = useDataContext()

  useLoad(
    async () => {
      apiFormTemplate.get(nodeID)
      apiListAsset.get(`${nodeID}/node`)
    },
    [nodeID]
  )

  const title = useMemo(() => apiFormTemplate.form.name, [apiFormTemplate.form])

  const handleSubmit = async data => {
    await apiFormTemplate.put(data.id, data)
    dataContext.reload()
  }

  const handleChange = () => dataContext.reload()

  const HeaderMenu = () => <TemplateMenu place="header" url={parentURL} node={apiFormTemplate.form} />

  return (
    <React.Fragment>
      {/* File versions is the node's menu page, mounted under this address:
          it is no page of Edit's (audit F16). */}
      <BreadcrumbView Icon={IconEdit} text="Edit" notOver={['publishes']}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <Card>
            <Form state={apiFormTemplate.form} disabled={!roleOrgNode.accessUpdate} onSubmit={handleSubmit}>
              <FormText label="name" name="name" required />
              <FormSubmit text="update" />
            </Form>
          </Card>

          {/* <NodeTags apiForm={apiFormTemplate} /> */}

          <ThumnailAsset nodeID={nodeID} onChange={handleChange} />
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${parentURL}/edit/publishes`}>
        <PublishAssetList nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
